import React from 'react';
import { useAuthentication } from 'contexts/AuthenticationProvider/AuthenticationProvider';
import { useSubscriptionsAndAllowedFeaturesContext } from 'contexts/SubscriptionsAndAllowedFeaturesContext/SubscriptionsAndAllowedFeaturesContext';
import { ArtistBannerParcel } from 'parcels/imported/ArtistBannerParcel';

export const ArtistBanner: React.FC = () => {
    const { isAuthenticated } = useAuthentication();
    const { isLoading, samplePaidContentAccess } =
        useSubscriptionsAndAllowedFeaturesContext();

    const showArtistBanner =
        !isLoading && (!isAuthenticated || !samplePaidContentAccess?.isAllowed);

    if (!showArtistBanner) {
        return null;
    }

    return <ArtistBannerParcel />;
};
